'use client';

import { useQueryParameter } from '@/shared/useQueryParameter';
import { FormEvent, useEffect, useState } from 'react';
import { PAGE_QUERY_KEY, SEARCH_QUERY_KEY } from '../../utils/constants';
import { SearchKeywordInput } from '@/app/components/shared/SearchKeywordInput';
import { useTagsSuggestion } from '../../details/hooks/useTagsSuggestion';

export function AssetsSearch() {
  const { searchTerm, setSearchTerm, submitSearch } = useQueryParameter(SEARCH_QUERY_KEY, [PAGE_QUERY_KEY]);
  const inputValue = searchTerm ? searchTerm.split(' ') : [];
  const [shouldSearch, setShouldSearch] = useState(false);

  useEffect(() => {
    if (shouldSearch) {
      setShouldSearch(false);
      submitSearch();
    }
  }, [shouldSearch, setShouldSearch, submitSearch]);

  const tags = useTagsSuggestion().filter((tag) => !searchTerm.includes(tag));

  return (
    <SearchKeywordInput
      name='term'
      data={tags}
      placeholder='Search assets'
      value={inputValue}
      onChange={(value) => {
        const newValue = Array.from(new Set(value.map((value) => value.split(' ')).flat()));
        setSearchTerm(newValue.join(' '));
        setShouldSearch(true);
      }}
    />
  );
}
